import {
  AudioInputState,
  AudioInputStateActive,
} from "@/types/defs/audioInput";

export const isAudioInputActive = (
  audioInput: AudioInputState
): audioInput is AudioInputStateActive => {
  const selectedFileCover = audioInput.selectedFileCover;
  return selectedFileCover !== null;
};
